import {React} from "react";
import {Link} from "react-router-dom";
import styled from "styled-components";
import Header from "./Header";
import Footer from "./Footer";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faArrowDown} from "@fortawesome/free-solid-svg-icons";
import MentorIcon from "./Mentor icon.png";
import PrototypeFront from './front mockup.png';
import RoryIcon from "./Rory icon.png";


const RoryMcIlroy = () => {
    return (
        <PageContainer>
            <Header/>
            <HomeContainer>
                <div style={{maxWidth: "630px", gap: '33px', display: 'flex', flexDirection: 'column'}}>
                    <div style={{display: 'flex', flexDirection: 'row'}}>
                        <div style={{fontSize: 72, fontWeight: 500}}>Rory</div>
                        <div style={{fontSize: 72, fontWeight: 500, color: '#4CAF50'}}>&nbsp;McIlroy</div>
                    </div>
                    <div style={{fontSize: 20}}>Rory McIlroy, a modern-day golf sensation, has captivated audiences with his dynamic playing style and remarkable technique.
                        Known for his prodigious drives and silky-smooth swing, McIlroy brings a blend of power and finesse to the golf course that has solidified his status as one of the game's top talents.
                        His impressive ball-striking ability, combined with a seemingly effortless rhythm, allows McIlroy to navigate courses with precision.</div>
                </div>
                <img src={RoryIcon} height='400px' alt={'pic'}></img>
            </HomeContainer>
            <HomeContainer>
                <img src={PrototypeFront} height='500px' alt={'pic'} ></img>
                <div style={{display: "flex", flexDirection: "column", textAlign:"end", justifyContent: "end", alignItems:"end"}}>
                    <div style={{fontSize: 72, fontWeight: 500}}>Elevate your game</div>
                    <p style={{fontSize: '20px'}}>Swing by Swing</p>
                    <StyledButton>Download <FontAwesomeIcon icon={faArrowDown}/></StyledButton>
                </div>
            </HomeContainer>
            <Footer/>
        </PageContainer>
    )
}

const PageContainer = styled.div`
    display: flex;
    overflow: hidden;
    width: 100%;
    flex-direction: column;
    justify-content: start;
    align-items: stretch;
    color: #fff;
    background-color: #0A0A0A;
    gap: 0;
`;

const HomeContainer = styled.div`
    height: 100vh;
    text-align: start;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    padding-left: 120px;
    padding-right: 120px;
    background-color: #0A0A0A;
    color: #fff;
    z-index: 0;
`;

const StyledButton = styled.button`
    background-color: #4CAF50;
    color: #0a0a0a;
    margin-top: 30px;
    margin-right: 10px;
    font-size: 18px;
    font-weight: 500;
    padding: 20px 40px;
    border: 2px solid #4CAF50;
    //border-radius: 10px;
    //text-shadow: 2px 1px 2px rgba(0,0,0,0.3);
    //box-shadow: 2px 4px 5px rgba(0,0,0,0.7);
    z-index: 1;
    &:hover {
        background-color: #0a0a0a;
        color: #4CAF50;
        border: 2px solid #4CAF50;
        transition: all 0.2s ease-in-out;
    }
`;

export default RoryMcIlroy;